import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import {commonPropTypes} from "./dependent-entities-selector";
import Select from "./select/select";


const EventSubDeploymentSelect = ({
                                      id = "typeId",
                                      name = "typeId",
                                      classes,
                                      label,
                                      contractId,
                                      isInsideForm,
                                      onChange,
                                      value,
                                      subDeployments,
                                      emptyValueText,
                                      ...props
                                  }) => {
    const [dependencyId, setDependencyId] = useState(contractId);
    const [existSubDeployments, setExistSubDeployments] = useState(false);

    useEffect(() => {
            if (contractId !== dependencyId) {
                setDependencyId(contractId);
                if (!contractId) {
                    onChange(name)(undefined);
                }
            }
        },
        [contractId, dependencyId],
    );

    useEffect(() => {
        setExistSubDeployments(Object.entries(subDeployments).length > 0);
    }, [subDeployments])


    const getValueFromElement = (element) => {
        return element;
    }
    const getLabelFromElement = (element) => {
        return element.name;
    }

    return (<>
            <Select
                className=""
                id={contractId + "subdeployments"}
                name="subdeployment"
                value={value}
                onChange={onChange}
                label={label}
                elements={subDeployments}
                spaced={false}
                disabled={false}
                marginDense={false}
                getValueFromElement={getValueFromElement}
                getLabelFromElement={getLabelFromElement}
                emptyValueText={emptyValueText}
            />
        </>
    );
};

EventSubDeploymentSelect.propTypes = {
    ...commonPropTypes,
    /**
     * Valor del selector
     */
    selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    /**
     * Valor del selector
     */
    value: PropTypes.object,
    /**
     * Contrato para el que se mostrarán los tipos de evento
     */
    contractId: PropTypes.string,
    /**
     * Valor del texto de la opción vacía, si existe (opcional)
     */
    emptyValueText: PropTypes.string,
};

export default EventSubDeploymentSelect;
